
import { Fragment } from "react";

import useExportEntries from './UseExportEntries';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import Headings from "@usas/ui-web/components/headings/Headings";
import MultiSelectCheckboxes from '@usas/ui-web/components/checkboxes/MultiSelectCheckboxes';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import CountryCombobox from "@usas/ui-web/components/comboboxes/countryCombobox/CountryCombobox";
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";

import Constants from '@usas/ui-web/utils/Constants';

const ExportEntries = () => {
  const {
    state,
    omeMeetState,
    omeMeetEntryInfoState,
    simpleFormState,
    simpleErrorState,
    omeEntriesExportState,
    onEntriesExportClicked,
    onSimpleFormValueChanged,
    onSimpleValueTextPairChanged
  } = useExportEntries();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Export Entries</Headings.H3>
        </div>
      </div>
      {omeMeetState.objData?.omeMeetId ?
        <Fragment>
          <div className="row usas-extra-bottom-margin">
            {state.checkBoxListItems?.length > 0 &&
              <div className="col-xs-12">
                {state.checkBoxListItems?.length > 1 ?
                  <MultiSelectCheckboxes
                    options={state.checkBoxListItems}
                    label="OME Meet*"
                    name="omeMeetEntryIds"
                    value={simpleFormState.omeMeetEntryIds}
                    error={simpleErrorState.omeMeetEntryIds}
                    message={simpleErrorState.omeMeetEntryIds}
                    onChange={(value) => {
                      onSimpleFormValueChanged('omeMeetEntryIds', value);
                    }}
                  /> :
                  <ReadOnly
                    label={"OME Meet"}
                    name="omeMeetEntryIds"
                    value={state.checkBoxListItems[0]?.name}
                  />
                }
              </div>}
          </div>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <YesNoSwitch
                label="International Meet?"
                name="isInternationalMeet"
                checked={simpleFormState.isInternationalMeet}
                error={simpleErrorState.isInternationalMeet}
                message={simpleErrorState.isInternationalMeet}
                onChange={(value) => { onSimpleFormValueChanged('isInternationalMeet', value) }} />
            </div>
            {simpleFormState.isInternationalMeet === true &&
              <div className={"col-xs-12 col-sm-6 col-md-4"}>
                <CountryCombobox
                  label="Country*"
                  name="country"
                  valueToMatch={simpleFormState.countryName}
                  error={simpleErrorState.country}
                  message={simpleErrorState.country}
                  onChange={(newValue, newValueLabel) => { onSimpleValueTextPairChanged(newValue, 'country', newValueLabel, 'countryName'); }} />
              </div>}
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <PrimaryButton onClick={onEntriesExportClicked}>Export Entries</PrimaryButton>
            </div>
          </div>
        </Fragment> :
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <p>The OME Meet has not been created yet. Exporting Entries is not allowed at this time.</p>
            </div>
          </div>
        </Fragment>
      }
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={omeEntriesExportState.isObjLoading || omeMeetEntryInfoState.isArrayLoading} />
    </Fragment>);
}

export default ExportEntries;